'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlToIFrameSrc = require('./urlToIFrameSrc');

var _urlToIFrameSrc2 = _interopRequireDefault(_urlToIFrameSrc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  urlToIFrameSrc: _urlToIFrameSrc2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-ugc/lib/video/index.js
// module id = 1568
// module chunks = 1